import api from "@/api"
import { Link } from "@inertiajs/react";
import { formatTime } from "@/utils/helper";

export default function Match({ match }) {
  return (
    <tr
      key={match.id}
      className="hover:bg-gray-50 transition-colors duration-150"
    >
      <td className="px-6 py-4 whitespace-nowrap">
        <div>
          <div className="text-sm font-medium text-gray-900">
            #{match.id}
          </div>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div>
          <div className="text-sm font-medium text-gray-900">
            {match.vacancy.title}
          </div>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="text-sm text-gray-900">
          {formatTime(match.created_at)}
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
        <div className="flex space-x-2">
          <Link href={api.matches.show.path({id: match.id})} className="text-blue-600 hover:text-blue-900 transition-colors duration-150">
            查看详情
          </Link>

          <Link href={api.matches.new.path({ query: { vacancy_id: match.vacancy_id } })} className="text-blue-600 hover:text-blue-900 transition-colors duration-150">
            重新匹配
          </Link>
        </div>
      </td>
    </tr>
  );
}
